import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiRequest } from '../utils/api';
import keepaiLogo from '../resource/keepaiLogo.png';
import '../css/style/admin.css';

const LoginRegisterPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.tab || 'login');
    const [form, setForm] = useState({
        userId: '',
        userName: '',
        phone: '',
        password: '',
        userIdChecked: null,
    });
    const [error, setError] = useState('');


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const data = await apiRequest('/login', 'POST', {
                userId: form.userId,
                password: form.password,
            });
            console.log("로그인 후후 :",data)
            if (data.success) {
                localStorage.setItem("user", JSON.stringify({ state: data.state, name: data.name, token: data.token }));

                window.dispatchEvent(new Event("login"));
                navigate("/");
            } else {
                setError('아이디 또는 비밀번호가 올바르지 않습니다.');
            }

        } catch (err) {
            setError('로그인 실패');
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        if (!isValidPhoneNumber(form.phone)) {
            setError("전화번호 형식이 올바르지 않습니다. 예: 01012345678");
            return;
        }

        if (form.userIdChecked !== true) {
            setError("아이디 중복확인을 완료해주세요.");
            return;
        }

        try {
            const data = await apiRequest('/register', 'POST', {
                userId: form.userId,
                userName: form.userName,
                phone: form.phone,
                password: form.password,
            });
            if (data.affectedRows === 1) {
                alert('회원가입 성공!');
                setActiveTab('login');
            } else {
                setError(data.message || '회원가입 실패');
            }
        } catch (err) {
            setError('회원가입 오류');
        }
    };

    const handleCheckUserId = async () => {
        if (!form.userId) {
            alert("아이디를 입력해주세요.");
            return;
        }

        try {
            const res = await apiRequest('/check-user-id', 'POST', { userId: form.userId });
            if (res.exists) {
                alert("이미 사용 중인 아이디입니다.");
                setForm(prev => ({ ...prev, userIdChecked: false }));
            } else {
                alert("사용 가능한 아이디입니다.");
                setForm(prev => ({ ...prev, userIdChecked: true }));
            }
        } catch (err) {
            alert("서버 오류");
        }
    };


    const isValidPhoneNumber = (phone) => {
        return /^01[0-9]{8,9}$/.test(phone); // 01012345678 ~ 01123456789 형식
    };
    return (
        <div className="login-page">
            <div className="login-top-bar">
                <img src={keepaiLogo} alt="KeepAi" className="login-logo" onClick={() => navigate('/')} />
            </div>
            <div className="login-card">

                <div className="tab-buttons">
                    <button onClick={() => setActiveTab('login')} className={activeTab === 'login' ? 'active' : ''}>로그인</button>
                    <button onClick={() => setActiveTab('register')} className={activeTab === 'register' ? 'active' : ''}>회원가입</button>
                </div>

                {activeTab === 'login' ? (
                    <form className="login-form" onSubmit={handleLogin}>
                        <div className="form-group">
                            <label>아이디</label>
                            <input name="userId" value={form.userId} onChange={handleChange} placeholder="아이디를 입력하세요" required />
                        </div>
                        <div className="form-group">
                            <label>비밀번호</label>
                            <input type="password" name="password" value={form.password} onChange={handleChange} placeholder="비밀번호를 입력하세요" required />
                        </div>
                        <button type="submit" className="btn-submit">로그인</button>
                    </form>
                ) : (
                    <form className="login-form" onSubmit={handleRegister}>
                        <div className="form-group">
                            <label>아이디</label>
                            <div className="input-with-btn">
                                <input name="userId" value={form.userId} onChange={handleChange} placeholder="사용할 아이디" required />
                                <button type="button" onClick={handleCheckUserId}>중복확인</button>
                            </div>
                            {form.userIdChecked === false && <span className="field-msg error">이미 사용 중인 아이디입니다.</span>}
                            {form.userIdChecked === true  && <span className="field-msg success">사용 가능한 아이디입니다.</span>}
                        </div>
                        <div className="form-group">
                            <label>이름</label>
                            <input name="userName" value={form.userName} onChange={handleChange} placeholder="실명을 입력하세요" required />
                        </div>
                        <div className="form-group">
                            <label>비밀번호</label>
                            <input type="password" name="password" value={form.password} onChange={handleChange} placeholder="비밀번호를 입력하세요" required />
                        </div>
                        <div className="form-group">
                            <label>전화번호</label>
                            <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="01012345678" required />
                        </div>
                        <button type="submit" className="btn-submit">회원가입</button>
                    </form>
                )}

                {error && <p className="error-text">{error}</p>}
            </div>
        </div>
    );
};

export default LoginRegisterPage;
